module.exports = __webpack_public_path__ + "static/media/qr-code-generation.1acc7cbf.svg";